import "./App.css";
import BenefitsSection from "./components/BenefitsSection";
import BookingSection from "./components/BookingSection";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Hero from "./components/Hero";
import ProcessSection from "./components/ProcessSection";

export default function App() {
  return (
    <main className="site-shell">
      <Header />
      <Hero />
      <ProcessSection />
      <BenefitsSection />
      <BookingSection />
      <Footer />
    </main>
  );
}
